<script>
import Vue from 'vue';
import GraphicAnimation from '../blocks/animations/GraphicAnimation';
import TableAnimation from '../blocks/table-animation/table-animation';
import { mapState } from 'vuex';
import { Slider, SliderItem } from 'vue-easy-slider';
import ZoomBox from '../blocks/zoom-box/zoom-box';
import { tremfya as tremfyaMenuItems } from '@/data/sections';
import { psoriasis as psoriasisMenuItems } from '@/data/sections';
import { TweenMax, Power1 } from 'gsap';

// import { scroller } from 'vue-scrollto/src/scrollTo';
var VueScrollTo = require('vue-scrollto');
let mobSlideScrollOpts = {
  container: 'body',
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: false,
  x: false,
  y: true
};

export default {
  data() {
    return {
      intersectionOptions: {
        callback: this.visibilityChanged,
        intersection: { rootMargin: '-20% 0px -70% 0px', threshold: 0.01 }
      },
      intersectionOptions2: {
        callback: this.visibilityChanged,
        intersection: { rootMargin: '-30% 0% -65% 0%', threshold: 0.01 }
      },
      activeTab: '',
      activeTabSecond: '',
      activeTip: '1',
      baseUrl: process.env.BASE_URL
    };
  },
  computed: {
    ...mapState(['userAgent']),
    activeSection() {
      if (this.userAgent.device.isMobile) {
        // console.log('Mob');
        return 'allSections';
      } else {
        // console.log('NoMob');
        return this.$store.state.currentSection;
      }
    }
  },
  components: {
    ZoomBox,
    GraphicAnimation,
    TableAnimation,
    Slider,
    SliderItem
  },

  watch: {
    '$store.state.currentSection'() {
      if (
        this.$store.state.changedDataLayer === 'tremfya-section' ||
        this.$store.state.changedDataLayer === 'psoriasis-section'
      ) {
        this.pushInfoToDatalayer('section');
      }
    }
  },
  created() {
    // set intersectionOptions for mobile
    if (this.userAgent.device.isMobile) {
      let opts = {
        rootMargin: '-50% 0px -50% 0px'
      };

      this.intersectionOptions.intersection = opts;
      this.intersectionOptions2.intersection = opts;
    }
  },
  methods: {
    isElementPartiallyInViewport(el) {
      var rect = el.getBoundingClientRect();
      // DOMRect { x: 8, y: 8, width: 100, height: 100, top: 8, right: 108, bottom: 108, left: 8 }
      var windowHeight =
        (window.innerHeight || document.documentElement.clientHeight) * 0.65;
      var windowMaxTop =
        (window.innerHeight || document.documentElement.clientHeight) * 0.15;

      // http://stackoverflow.com/questions/325933/determine-whether-two-date-ranges-overlap
      var vertInView =
        rect.top <= windowHeight && rect.top + rect.height >= windowMaxTop;

      return vertInView;
    },
    contentScrollHandle() {
      let list = document.querySelectorAll(
        "div[id^='subsection'] > .container > .content-wrapper > *"
      );

      for (var i = 0; i < list.length; i++) {
        let el = list[i];
        if (this.isElementPartiallyInViewport(el)) {
          el.classList.add('contentActive');
        } else {
          el.classList.remove('contentActive');
        }
      }
    },
    setRouteExplicit(section, subsection) {
      // this.$router.push('/tremfya/' + section + '/' + subsection);
      // console.log('->', section, subsection);
      this.$store.commit('setCurrentSection', {
        section: section + '',
        subsection: subsection + ''
      });

      let list =
        this.$route.meta.page == 'Tremfya'
          ? tremfyaMenuItems
          : psoriasisMenuItems;

      let secInt = parseInt(section) - 1;
      let subInt = parseInt(subsection) - 1;

      let subsec = list[secInt].subsections[subInt];

      // console.log(subsec);

      // this.$store.commit('setExplicitSection', '');
      this.$store.commit('setExplicitSubsection', subsec.name);
      this.$store.commit('setExplicitSlideIndex', subInt);
    },
    onStart() {
      this.$store.commit('BTN_SCROLL', true);
    },
    onDone() {
      this.$store.commit('BTN_SCROLL', false);
    },
    onCancel() {
      this.$store.commit('BTN_SCROLL', false);
    },
    microScroll(rt) {
      // console.log('Slide to', rt);
      setTimeout(function() {
        VueScrollTo.scrollTo(rt.target, 500, mobSlideScrollOpts);
      }, 50);
    },
    activateTab(el, rt) {
      this.activeTab = el;
      if (typeof rt !== 'undefined') {
        this.microScroll(rt);
      }
    },
    activateTabSecond(el, rt) {
      this.activeTabSecond = el;
      if (typeof rt !== 'undefined') {
        this.microScroll(rt);
      }
    },
    activateTip(el, rt) {
      this.activeTip = el;
      if (typeof rt !== 'undefined') {
        this.microScroll(rt);
      }
    },
    visibilityChanged(isVisible, entry) {
      if (isVisible && this.userAgent.device.isMobile) {
        if (/^section-/.test(entry.target.id)) {
          // const currentMobileSection = entry.target.dataset.menu;
          // this.$store.state.currentMobileSubmenu = currentMobileSection;

          this.$store.state.currentMobileSubmenu = entry.target
            .getAttribute('id')
            .split('-')[1];
          try {
            this.$store.state.choosenMobileSubmenuItems = this.$store.getters.activeMobileSubection.subsections;
          } catch (e) {
            //
          }
        }
      } else if (!this.userAgent.device.isMobile && isVisible) {
        // console.log(entry);
        if (/^subsection-/.test(entry.target.id)) {
          let route = entry.target.id.split('-');
          this.setRouteExplicit(route[1], route[2]);
          this.contentScrollHandle();
          this.pushInfoToDatalayer('subsection');
        }
      }
    },
    setSection(obj) {
      this.$store.commit('setRouteFromParams', {
        name: this.$route.meta.page,
        params: {
          ...obj
        }
      });
    },
    clickOnViewStudyDesign() {
      // let ScrollTo = scroller();

      let options = {
        container: this.userAgent.device.isMobile ? 'body' : '.js-content',
        easing: 'ease',
        offset: this.userAgent.device.isMobile ? -100 : -230,
        force: true,
        cancelable: false,
        onStart: this.onStart,
        onDone: this.onDone,
        onCancel: this.onCancel,
        x: false,
        y: true
      };

      VueScrollTo.scrollTo('#element', 500, options);

      // ScrollTo('#element', 300, {
      //   container: this.userAgent.device.isMobile ? 'body' : '.js-content',
      //   easing: 'linear',
      //   offset: this.userAgent.device.isMobile ? -100 : -230,
      //   force: true,
      //   cancelable: false,
      //   onStart: this.onStart,
      //   onDone: this.onDone,
      //   onCancel: this.onCancel,
      //   x: false,
      //   y: true
      // });
    },
    // push data to Datalayer
    pushInfoToDatalayer(target) {
      //push data to Datalayer on links click
      if (
        this.$store.state.changedDataLayer === 'psoriasis' ||
        this.$store.state.changedDataLayer === 'tremfya'
      ) {
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'link-click',
            section: this.$store.state.changedDataLayer
          });
          // console.log(window.dataLayer);
        }
      }

      // push stages to Datalayer on scroll
      // Sections
      if (target === 'section') {
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'scroll-tracking',
            section: this.$store.getters.page,
            stage: this.$store.state.currentSection,
            'stage-name': this.$store.getters.activeSection.name.replace(
              /<[^>]*>/g,
              ''
            )
          });
          // console.log(window.dataLayer);
        }
      }

      // Subsections
      if (target === 'subsection') {
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'scroll-tracking',
            section: this.$store.getters.page,
            stage: this.$store.state.currentSection,
            'stage-name': this.$store.state.explicitSubsectionName
              .replace(/<[^>]*>/g, '')
              .replace(/&#39;/g, '')
          });
          // console.log(window.dataLayer);
        }
      }
    }
  },
  mounted() {
    this.activeTab = 'default';
    this.activeTabSecond = 'default';
    this.$nextTick(() => {
      // A fix for Blinking
      if (this.userAgent.device.isMobile) {
        let ssw = document.querySelector('.super-scroll-wrapper');
        let hdr = document.querySelector('.header');
        let logos = hdr.querySelector('.logos');

        if (ssw && hdr && logos) {
          ssw.style.opacity = 0;
          logos.style.opacity = 0;
          hdr.style.top = '-150px';
          TweenMax.to(ssw, 1.0, { opacity: 1, delay: 0.5 });
          TweenMax.to(hdr, 0.7, {
            top: '0px',
            delay: 0.5,
            ease: Power1.easeOut
          });
          TweenMax.to(logos, 1.0, { opacity: 1, delay: 1 });
          TweenMax.to('.starting_overlay', 0.2, {
            opacity: 0,
            display: 'none',
            delay: 1
          });
        } else {
          console.warn('Catn run tween for hide blinkig');
        }
      }
    });

    if (!this.userAgent.device.isMobile) {
      let el = document.querySelector('.super-scroll-wrapper');

      // console.log('is NOT Mobile');
      Vue.vuebar.initScrollbar(el, { preventParentScroll: true });
      // Vue.vuebar.refreshScrollbar(el, { preventParentScroll: true });
      document
        .querySelector('.js-content')
        .addEventListener('scroll', this.contentScrollHandle);
    }

    this.pushInfoToDatalayer();
  },
  beforeDestroy() {
    TweenMax.set('.starting_overlay', { opacity: 1, display: 'block' }, 0);
    if (!this.userAgent.device.isMobile) {
      let el = document.querySelector('.js-content');

      if (el) {
        el.removeEventListener('scroll', this.contentScrollHandle);
      }
    }
  }
};
</script>
